/**
 * 判断传入值是否为 Blob URL。
 * @param {*} url 需要判断的 URL 值
 * @returns {boolean} 是否为 Blob URL
 */
export function isBlobUrl(url) {
  return typeof url === 'string' && /^blob:/i.test(url);
}

/**
 * 为文件创建 Blob URL，并记录 URL 到 File 的映射。
 * @param {File|Blob} file 需要创建 URL 的文件对象
 * @returns {string} 创建得到的 Blob URL
 */
export function createFileBlobUrl(file) {
  const blobUrl = (window.URL || window.webkitURL).createObjectURL(file);
  // 初始化文件映射表，便于上传接口通过 Blob URL 找回原始文件。
  if (!window.__fileUrlMap) {
    window.__fileUrlMap = {};
  }
  window.__fileUrlMap[blobUrl] = file;
  return blobUrl;
}

/**
 * 释放 Blob URL，并同步移除文件映射缓存。
 * @param {*} url 需要释放的 URL
 * @returns {boolean} 是否执行了释放
 */
export function revokeBlobUrl(url) {
  // 只有真实 Blob URL 才允许释放，避免误处理线上图片地址。
  if (!isBlobUrl(url)) {
    return false;
  }
  try {
    // fileToBlobUrl 写入的映射会强引用 File，释放 URL 时必须同步删除。
    if (window.__fileUrlMap && window.__fileUrlMap[url]) {
      delete window.__fileUrlMap[url];
    }
  } catch (error) {}
  // 缺少 URL API 时无法执行浏览器原生释放。
  if (typeof URL === 'undefined' || typeof URL.revokeObjectURL !== 'function') {
    return false;
  }
  URL.revokeObjectURL(url);
  return true;
}
